import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    type_profile: 1,
    data_message: [],
    infor_header:
      'Xin vui lòng điền vào mẫu dưới đây để chúng tôi có thể dễ dàng liên lạc hơn với bạn.',
    ass_header:
      'Hãy gửi tin nhắn và chúng tôi sẽ cố gắng trả lời bạn trong thời gian ngắn nhất',
    support: true,
    connet: true,
    send_cookie: true
  },
  initialize(o) {
    
  }
});
